(function () {
  function deliveryPrice(groups) {
    if (!groups || groups.pageInfo?.hasNextPage || !groups.nodes?.length) return null;
    let total = 0;
    for (const group of groups.nodes) {
      const prices = group.deliveryOptions.filter(o => ['SHIPPING', 'LOCAL'].includes(o.deliveryMethodType) && o.estimatedCost.currencyCode === 'CLP').map(o => Number(o.estimatedCost.amount) * 100).filter(n => Number.isFinite(n) && n >= 0);
      if (!prices.length) return null;
      total += Math.min(...prices);
    }
    return Math.round(total);
  }
  if (typeof module !== 'undefined' && module.exports) {module.exports = {deliveryPrice}; return;}
  if (window.MHRegionShipping) return;
  const data = JSON.parse(document.getElementById('mh-shipping-rates').textContent);
  const KEY = 'Región de despacho', CODE = 'Region despacho codigo';
  const root = window.Shopify.routes.root;
  const widgets = () => [...document.querySelectorAll('mh-region-shipping')];
  const money = value => new Intl.NumberFormat('es-CL',{style:'currency',currency:'CLP',maximumFractionDigits:0}).format(value / 100);
  let selected = '', cart = null, version = 0, saveQueue = Promise.resolve(), intent = 0, cacheKey = '', cachedPrice = null;
  const api = async (path, body) => {
    const r = await fetch(root + path,{method:body ? 'POST':'GET',headers:{Accept:'application/json','Content-Type':'application/json'},...(body ? {body:JSON.stringify(body)} : {}),signal:AbortSignal.timeout(15000)});
    if (!r.ok) throw new Error('No se pudo consultar el despacho');
    return r.json();
  };
  function originalTotal(w, visible) {
    const footer = w.closest('.drawer__footer') || w.closest('[id^="shopify-section-"]');
    footer?.querySelectorAll('[data-mh-original-totals], .tax-note').forEach(el => {el.hidden = !visible;});
  }
  function result(w, price, note) {
    const out = w.querySelector('[data-shipping-result]');
    out.textContent = note !== undefined ? note : price === null ? '' : price === 0 ? 'Entrega a domicilio: gratis' : 'Entrega a domicilio: ' + money(price);
    out.hidden = !out.textContent;
    const addressNote = w.querySelector('[data-shipping-address-note]');
    if (addressNote) addressNote.hidden = price === null;
    const total = w.querySelector('[data-shipping-total]');
    const summary = w.closest('.drawer__footer')?.querySelector('.mh-cart-summary');
    if (summary && w.dataset.context !== 'product') {
      let delivery = summary.querySelector('[data-summary-delivery]');
      if (!delivery) {
        delivery = document.createElement('div');
        delivery.dataset.summaryDelivery = '';
        delivery.style.cssText = 'display:flex;justify-content:space-between;gap:12px;padding:10px 0 12px;font-size:14px;color:#3e4b2e';
        const label = document.createElement('span');
        label.textContent = 'Despacho estimado';
        const amount = document.createElement('strong');
        amount.style.marginRight = '28px';
        delivery.append(label, amount);
        summary.querySelector('[data-mh-original-totals]').before(delivery);
      }
      delivery.style.display = selected ? 'flex' : 'none';
      delivery.querySelector('strong').textContent = price === null ? 'Por confirmar' : price === 0 ? 'Gratis' : money(price);
      const original = summary.querySelector('[data-mh-original-totals]');
      original.hidden = false;
      if (cart) original.querySelector('.totals__total-value').textContent = money(cart.total_price + (price === null ? 0 : price)) + ' CLP';
      if (total) total.hidden = true;
      const breakdown = w.querySelector('[data-shipping-breakdown]');
      if (breakdown) breakdown.hidden = true;
      originalTotal(w, true);
      return;
    }
    if (total) {
      total.hidden = price === null || !cart;
      total.querySelector('strong').textContent = price === null || !cart ? '' : money(cart.total_price + price) + ' CLP';
      const breakdown = w.querySelector('[data-shipping-breakdown]');
      if (breakdown) {
        breakdown.hidden = price === null || !cart;
        if (cart && price !== null) {
          w.querySelector('[data-breakdown-products]').textContent = money(cart.original_total_price);
          w.querySelector('[data-breakdown-saving]').textContent = (cart.total_discount ? '−' : '') + money(cart.total_discount);
          w.querySelector('[data-breakdown-delivery]').textContent = price === 0 ? 'Gratis' : money(price);
        }
      }
      originalTotal(w, price === null);
    }
  }
  const productQuotes = new Map();
  const productState = new WeakMap();
  const productQuery = `mutation ShippingEstimate($input: CartInput) {
    cartCreate(input: $input) {
      cart { totalQuantity deliveryGroups(first: 10) { nodes { deliveryOptions { deliveryMethodType estimatedCost { amount currencyCode } } } pageInfo { hasNextPage } } }
      userErrors { message }
    }
  }`;
  async function productQuote(variant, quantity, region, sellingPlan) {
    const response = await fetch('/api/2026-07/graphql.json', {
      method: 'POST', credentials: 'omit', headers: {'Content-Type':'application/json', Accept:'application/json'},
      signal: AbortSignal.timeout(15000),
      body: JSON.stringify({query: productQuery, variables: {input: {
        lines: [{merchandiseId: 'gid://shopify/ProductVariant/' + variant.id, quantity, ...(sellingPlan ? {sellingPlanId: 'gid://shopify/SellingPlan/' + sellingPlan} : {})}],
        buyerIdentity: {countryCode: 'CL'},
        delivery: {addresses: [{selected: true, address: {deliveryAddress: {countryCode: 'CL', provinceCode: region}}}]}
      }}})
    });
    if (!response.ok) throw new Error('No se pudo consultar la tarifa');
    const payload = await response.json();
    const quote = payload.data?.cartCreate;
    if (payload.errors?.length || quote?.userErrors?.length || quote?.cart?.totalQuantity !== quantity) throw new Error('Selección no disponible');
    const price = deliveryPrice(quote.cart.deliveryGroups);
    if (price === null) throw new Error('Sin tarifa para esta selección');
    return price;
  }
  function renderProduct(w) {
    const info = w.closest('product-info') || w.closest('[id^="ProductInfo-"]') || document;
    const variants = JSON.parse(w.querySelector('[data-shipping-variants]').textContent);
    const id = info.querySelector('product-form form [name="id"]')?.value || w.dataset.variant;
    const v = variants.find(v => String(v.id) === String(id));
    const qty = Number(info.querySelector('input[name="quantity"]')?.value || 1);
    const sellingPlan = info.querySelector('product-form form [name="selling_plan"]')?.value || '';
    const signature = JSON.stringify([id, qty, selected, sellingPlan]);
    const previous = productState.get(w);
    if (previous?.signature === signature && Date.now() - previous.at < 30000) return;
    clearTimeout(previous?.timer);
    const state = {signature, at: Date.now()};
    productState.set(w, state);
    if (!selected) {result(w, null, 'Consulta informativa: el despacho se confirma al pagar.'); return;}
    if (!v || !Number.isInteger(qty) || qty < 1) {result(w, null, 'Selecciona un producto y una cantidad válidos.'); return;}
    if (v.requires_shipping === false) {result(w, 0); return;}
    result(w, null, 'Consultando despacho…');
    const region = selected;
    state.timer = setTimeout(async () => {
      try {
        let cached = productQuotes.get(signature);
        if (!cached || Date.now() - cached.at >= 30000) {
          cached = {at: Date.now(), promise: productQuote(v, qty, region, sellingPlan)};
          productQuotes.set(signature, cached);
        }
        const price = await cached.promise;
        if (w.isConnected && productState.get(w) === state) result(w, price);
      } catch (_) {
        productQuotes.delete(signature);
        if (w.isConnected && productState.get(w) === state) {
          state.at = 0;
          result(w, null, 'No pudimos consultar la tarifa. El valor se confirma en el carrito con tu dirección.');
        }
      }
    }, 450);
  }
  function paint() {
    widgets().forEach(w => {w.querySelector('select').value = selected; if(w.dataset.context === 'product') renderProduct(w);});
  }
  async function quote() {
    const revision = ++version;
    const targets = widgets().filter(w => w.dataset.context !== 'product');
    if (!targets.length) return;
    if (!selected) {targets.forEach(w=>result(w,null,'')); return;}
    targets.forEach(w=>result(w,null,'Calculando despacho…'));
    try {
      const current = await api('cart.js');
      if (revision !== version) return;
      cart = current;
      const region = data.regions.find(r=>r.code===selected);
      if (!region) throw new Error('Región inválida');
      const signature = selected + JSON.stringify([current.total_price,current.items.map(i=>[i.key,i.quantity,i.grams])]);
      let price;
      if (current.requires_shipping === false) price = 0;
      else if (signature === cacheKey) price = cachedPrice;
      else {
        const params = new URLSearchParams({'shipping_address[country]':'Chile','shipping_address[province]':region.province});
        const rates = await api('cart/shipping_rates.json?' + params);
        if (revision !== version) return;
        const amounts = (rates.shipping_rates || []).filter(r=>!r.currency || r.currency === 'CLP').map(r=>Number(r.price)*100).filter(n=>Number.isFinite(n)&&n>=0);
        if (!amounts.length) throw new Error('No hay tarifa');
        price = Math.min(...amounts); cacheKey=signature; cachedPrice=price;
      }
      if (revision !== version) return;
      targets.filter(w=>w.isConnected).forEach(w=>result(w,price));
    } catch (_) {
      if (revision !== version) return;
      targets.filter(w=>w.isConnected).forEach(w=>result(w,null,'No pudimos calcular el despacho. Confirma tu dirección en el checkout.'));
    }
  }
  async function refresh() {
    const before = intent;
    try {
      await saveQueue;
      const current = await api('cart.js');
      if (before !== intent) return;
      cart=current;
      selected=data.regions.some(r=>r.code===current.attributes?.[CODE]) ? current.attributes[CODE] : '';
      paint(); quote();
    } catch (_) {widgets().filter(w=>w.dataset.context!=='product').forEach(w=>result(w,null,'No pudimos consultar el despacho. Inténtalo nuevamente.'));}
  }
  function choose(value) {
    selected=value; intent++; const currentIntent=intent; paint(); quote();
    const region=data.regions.find(r=>r.code===value);
    saveQueue=saveQueue.catch(()=>{}).then(async()=>{
      const updated=await api('cart/update.js',{attributes:{[KEY]:region?.name||'',[CODE]:region?.code||''}});
      if((updated.attributes?.[CODE]||'')!==value) throw new Error('No guardado');
      if(currentIntent===intent){cart=updated;paint();quote();}
    }).catch(()=>{if(currentIntent===intent)widgets().forEach(w=>result(w,null,'No se guardó la región. Puedes reintentar o continuar y elegir tu dirección al pagar.'));});
  }
  window.MHRegionShipping={refresh};
  customElements.define('mh-region-shipping',class extends HTMLElement {
    connectedCallback() {
      if(this.ready)return;this.ready=true;
      const select=this.querySelector('select');
      select.replaceChildren(new Option('Selecciona tu región',''),...data.regions.map(r=>new Option(r.name,r.code)));
      select.addEventListener('change',()=>choose(select.value));
      refresh();
    }
  });
  document.addEventListener('change',e=>{if(e.target.matches('input[name="quantity"],input[name="id"],[name="selling_plan"]'))paint();});
  if(typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined'){
    subscribe(PUB_SUB_EVENTS.variantChange,()=>setTimeout(paint,0));
    subscribe(PUB_SUB_EVENTS.cartUpdate,()=>{cacheKey='';setTimeout(refresh,0);});
  }
  document.addEventListener('visibilitychange',()=>{if(!document.hidden)refresh();});
})();


